import React from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from 'utils/util';
import CmsPreviewShell from "./CmsPreviewShell";

const CategoryComponent = ({  layout, items = [] }) => {
  const navigate = useNavigate();
  return (
    <CmsPreviewShell>
      <div className={`cms-category cms-category--${layout}`}>
        {items.map((item) =>{
          const isActive = item.is_active
          return (
            isActive && 
              <div key={item.id} className="cms-category__item" onClick={()=>{linkOpen(item.link, navigate)}}>
                <span className="cms-category__icon">
                  {typeof item.icon === "string" && item.icon.startsWith("http") ? (
                    <img
                      className="cms-category__icon-img"
                      src={item.icon}
                      alt={item.title || ""}
                    />
                  ) : (
                    item.icon
                  )}
                </span>
                <span className="cms-category__name">{item.title}</span>
            </div>
        )})}
      </div>
    </CmsPreviewShell>
  );
};

export default CategoryComponent;
